<template>
    <Layout ref="pageRef">
    <template v-slot:navigation>
      <Navigation :showMenu="true">
        <!-- transparent!!!!! -->
        <template v-slot:title>
          <router-link class="title" to="/">Samsung Upcycle-Packaging</router-link>
        </template>
      </Navigation>
    </template>
    
      <template v-if="lang === 'en'" v-slot:content>
     <policy-en ></policy-en>
     </template>
     <template v-else-if="lang === 'ko'" v-slot:content>
     <policy-ko ></policy-ko>
     </template>
    <template v-else-if="lang === 'es'" v-slot:content>
       <policy-es></policy-es>
     </template> 
       <template v-else-if="lang === 'es-ES'" v-slot:content>
       <policy-eses></policy-eses>
     </template> 
       <template v-else-if="lang === 'fr'" v-slot:content>
       <policy-fr></policy-fr>
     </template> 
       <template v-else-if="lang === 'it'" v-slot:content>
       <policy-it></policy-it>
     </template> 
       <template v-else-if="lang === 'pt'" v-slot:content>
       <policy-pt></policy-pt>
     </template> 
       <template v-else-if="lang === 'ru'" v-slot:content>
       <policy-ru></policy-ru>
     </template> 
       <template v-else-if="lang === 'uk-UA'" v-slot:content>
       <policy-ukua></policy-ukua>
     </template> 
       <template v-else-if="lang === 'zh-CN'" v-slot:content>
       <policy-zhcn></policy-zhcn>
     </template> 
    <template v-else-if="lang === 'zh-HK'" v-slot:content>
       <policy-zhhk></policy-zhhk>
     </template> 
    <template v-else-if="lang === 'zh-TW'" v-slot:content>
     <policy-zhtw ></policy-zhtw>
     </template>

    <template v-slot:footer>
      <Footer />
    </template>
  </Layout>
</template>

<script>

import Navigation from "../../style/Navigation.vue";
import Footer from "../../style/Footer.vue";
import Layout from "../../style/Layout.vue";
import { language } from "../../../util/language";
import policyEN from "./en"
import policyKO from "./ko"
import policyES from "./es"
import policyESES from "./eses"
import policyFR from "./fr"
import policyIT from "./it"
import policyPT from "./pt"
import policyRU from "./ru"
import policyUKUA from "./ukua"
import policyZHCN from "./zhcn"
import policyZHHK from "./zhhk"
import policyZHTW from "./zhtw"


export default {
  components: {
    Navigation,
    Footer,
    Layout,
    'policy-ko' :policyKO,
    'policy-en' :policyEN,
    'policy-es' :policyES,
    'policy-eses' :policyESES,
    'policy-fr' :policyFR,
    'policy-it' :policyIT,
    'policy-pt' :policyPT,
    'policy-ru' :policyRU,
    'policy-ukua' :policyUKUA,
    'policy-zhcn' :policyZHCN,
    'policy-zhhk' :policyZHHK,
    'policy-zhtw' :policyZHTW,

  },
  data() {
    return {
      lang: ".",
      // locales: [
      //   {id: "en"},
      //   {id: "ko"},
      //   {id: "es"},
      //   {id: "es-ES"},
      //   {id: "fr"},
      //   {id: "it"},
      //   {id: "pt"},
      //   {id: "ru"},
      //   {id: "uk-UA"},
      //   {id: "zh-CN"},
      //   {id: "zh-HK"},
      //   {id: "zh-TW"}
      // ]
     };
  },
  created() {
       this.lang = language.getLanguage();
    // this.locales = this.locales.sort((a, b) => {
    //   return a > b ? 1 : -1;
    // });
    // this.locales = this.locales.sort(a => {
    //   return a.id === lang ? -1 : 0;
    // });
    window.scrollTo(0, 0);
    this.$forceUpdate();

  },
  methods: {
    // changeLocale(e) {
    //   window.scrollTo(0, 0);
      // this.$i18n.locale = e.target.value;
      // document.querySelector("html").setAttribute("lang", e.target.value);
      // language.setLanguage(e.target.value);
      // location.reload();
    // }

  },
  mounted() {
    this.$nextTick(() => {
      this.lang = language.getLanguage();
      this.$forceUpdate();
    });
  },
};
</script>

<style scoped>
.footer-wrapper {
  background-color: black;
}

.hi{
  margin-top: 128px;
  /* background-color: #FFFFFF; */
  text-align: left;
  /* min-height: 80vh; */
  position:relative;
}
table{
  border-collapse:collapse;
  width:100%;
  text-align:center;
}
td,th{
  padding:0;
}
td,th{
  border: 1px solid #FFFFFF;
}
ul,ol{
  list-style:none;
}
dl,ul,ol,li,dt,dd,blockquote,p,h1,h2,h3,h4,h5,h6{
  padding:0;
  margin:0;
  text-align:left;
}

@media (max-width: 1024px) {
 
}
</style>
